export const roomDetailData = [
  {
    _id: '64b673d537719941a03b3ddc',
    roomType: 'royal suite',
    totalRooms: 5,
    features: ['free wifi,Mini Bar,Tea/Coffee maker,Mini Fridge,Safe Deposit Locker'],
  },
  {
    _id: '64b6d827396a8870eb686c42',
    roomType: 'super deluxe',
    totalRooms: 10,
    features: ['free wifi,free breakfast'],
  },
  {
    _id: '64b6ec81396a8870eb686d4d',
    roomType: 'deluxe',
    totalRooms: 20,
    features: ['free wifi,free coffee'],
  },
];
